var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextarea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_136_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_137_",
    d: "M3.7,16.2H11c0.2,0,0.4-0.2,0.4-0.4V15c0-0.2-0.2-0.4-0.4-0.4H8.1V4.9H11c0.2,0,0.4-0.2,0.4-0.4V3.7 c0-0.2-0.2-0.4-0.4-0.4H8.1H6.5H3.7c-0.2,0-0.4,0.2-0.4,0.4v0.8c0,0.2,0.2,0.4,0.4,0.4h2.8v9.8H3.7c-0.2,0-0.4,0.2-0.4,0.4v0.8 C3.2,16.1,3.4,16.2,3.7,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_146_",
    d: "M18.5,23.6c0.2,0.2,0.4,0.2,0.6,0l4.6-4.6c0.2-0.2,0.2-0.4,0-0.6l-0.6-0.6c-0.2-0.2-0.4-0.2-0.6,0 l-4.6,4.6c-0.2,0.2-0.2,0.4,0,0.6L18.5,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    d: "M23.1,20.5l-2.6,2.6c-0.2,0.2-0.2,0.4,0,0.6l0.6,0.6c0.2,0.2,0.4,0.2,0.6,0l2.6-2.6 c0.2-0.2,0.2-0.4,0-0.6l-0.6-0.6C23.5,20.4,23.3,20.4,23.1,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    d: "M24.4,0H1.6C0.7,0,0,0.7,0,1.6v22.8C0,25.3,0.7,26,1.6,26h22.8c0.9,0,1.6-0.7,1.6-1.6V1.6 C26,0.7,25.3,0,24.4,0z M24.4,24.4H1.6V1.6h22.8V24.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextarea);
export default __webpack_public_path__ + "static/media/Textarea.60ec63f6afdea32ab8a00b5dc7f5bef5.svg";
export { ForwardRef as ReactComponent };